import type { OtroTramiteType } from '../types';
import type { MetodoPago } from '../types/cobros';
import { BadgeCheck, ClipboardList, Wallet, Zap } from 'lucide-react';

export const TIPO_TRAMITE_OPTIONS: OtroTramiteType[] = [
  'Certificación de firma',
  'Certificación de copia',
  'Poder general',
  'Poder especial',
  'Autorización menor',
  'Autorización conducir',
  'Contrato',
];

export const METRIC_CARD_META = [
  {
    icon: ClipboardList,
    iconClasses: 'bg-blue-100 text-blue-600',
  },
  {
    icon: Zap,
    iconClasses: 'bg-amber-100 text-amber-700',
  },
  {
    icon: BadgeCheck,
    iconClasses: 'bg-emerald-100 text-emerald-700',
  },
  {
    icon: Wallet,
    iconClasses: 'bg-rose-100 text-rose-700',
  },
] as const;

export const OTORGANTES_QUERY_KEY = ['otros-tramites', 'catalog', 'otorgantes'] as const;
export const RESPONSABLES_QUERY_KEY = ['otros-tramites', 'catalog', 'responsables'] as const;

export const METODOS_PAGO_OPTIONS: MetodoPago[] = [
  'Efectivo',
  'Transferencia',
];

export const METODO_PAGO_LABELS: Record<MetodoPago, string> = {
  'Efectivo': 'Efectivo',
  'Transferencia': 'Transferencia',
};
